import React from "react";
import EnquiryService from "../../../Services/EnquiryService";
import EnquiryHelper from "./EnquiryHelper"

export default function Referral({ setDetail, detail, setamount, totaldeliver, setFreight, validator, setpercentvalue }) {

    const codeHandler = (event) => {
        const { value, name } = event.target;
        if (name === "promotion_code" && value) {
            setDetail({
                ...detail,
                promo_code: value,
            });
            let postToken = {
                promo_code: value,
            };
            EnquiryService.productReferralCode(postToken).then((res) => {
                if (res.status === true) {
                    let discountAmt = EnquiryHelper.getDiscountbyPercentage(res.data.customer_discount, totaldeliver);
                    setpercentvalue(res.data.customer_discount);
                    setamount(discountAmt);
                    let finalAmount = Number(totaldeliver) - Number(discountAmt);
                    setFreight(finalAmount);
                    // setFreight(discountAmt?.total_discount)
                    // let totalAmt = EnquiryHelper.subTotalfun(totalfreight, insurance, storage)
                    // setFreight(totalAmt)
                }
            });
        }
    };


    // const getDiscountbyPercentage = (percentageCode) => {
    //     const percentageAmount =
    //         (Number(totaldeliver ? totaldeliver : totalpacking) *
    //             Number(percentageCode)) /
    //         100;
    //     if (percentageAmount) {
    //         var discountAmt =
    //             Number(totalfreight ? totalfreight : totalpacking) -
    //             percentageAmount;
    //     }
    //     setamount(discountAmt);
    // };

    return (
        <>
    <div className="mb-3 col-4">
        <label className="form-label">Enter Referral code / Promo Code</label>
            <input
                className="form-control"
                type="text"
                placeholder="Enter Referral Code"
                name="referral_code"
                onChange={(e) => codeHandler(e)}
                value={detail.referral_code || detail?.promo_code}
                readOnly={totaldeliver ? true : false}
            />
            {(detail.retailer_name &&
                detail.retailer_name !== "None") &&
                validator.current.message(
                    "Referral Code",
                    detail.referral_code,
                    "required",
                    { className: "text-danger text-capitalize" }
                )}
        </div>

    {/* <div className="mb-3 col-2">
                <label className="form-label">Promo Code</label>
                <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Promo Code"
                    name="promotion_code"
                    onChange={(e) => codeHandler(e)}
                    value={detail.promo_code}
                    readOnly={totaldeliver ? true : false}
                />
                {(detail.retailer_name &&
                    detail.retailer_name != "None") &&
                    validator.current.message(
                        "Promo Code",
                        detail.promo_code,
                        "required",
                        { className: "text-danger text-capitalize" }
                    )}
            </div> */}
        </>

    )
}